// react
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from 'react-router';

// kendo
import { Dialog, DialogActionsBar, Window, WindowActionsBar } from '@progress/kendo-react-dialogs';

// css
import styles from './footer_mobile.module.css';
import './footer_mobile.css';

// services
import { authGuest, setDelToken, setToken, isLogin, getUser } from "../../service/authService";

function FooterMobile({}) {

  const history = useHistory();
  const location = useLocation();
  const userInfo = getUser();

  const [path, setPath] = useState({
    home: false,
    add: false,
    noti: false,
    info: false,
  }) 

  const [phoneModel, setPhoneModel] = useState("");

  // DIALOG 설정
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }

  const goHome = () => {
    if(userInfo.userTypeCode === 2001 || userInfo.userTypeCode === 2006) {
      history.push({
        pathname: "/user/info",
      });
    } else {
      history.push({
        pathname: "/user/list",
      });
    }
  }

  const goAddUser = () => {
    if(userInfo.userTypeCode === 2001) {
      setCompleteDialogVisible(true);
      return;
    } else {
      history.push({
        pathname: "/add",
      });
    }
  }

  const goNotiLog = () => {
    history.push({
      pathname: "/notiLog",
      // state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
    // if(phoneModel === "android") {
    // } else if(phoneModel === "ios") {
    //   setCompleteDialogVisible(true);
    //   return ;
    // } else {
    //   setCompleteDialogVisible(true);
    //   return ;
    // }
  }

  const goAccount = () => {
    history.push({
      pathname: "/account",
      // state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
  }

  // 푸터 선택 화면 표시
  const showSelectPage = () => {
    // 홈 화면 일시
    if(location.pathname === '/user/list' || location.pathname === '/user/info' || location.pathname === '/user/detail' || location.pathname === '/user/monitor' || location.pathname === '/help') {
      setPath(path => {
        const item = { ...path };
        item.home = true;
        item.add = false;
        item.noti = false;
        item.info = false;
        return item;
      })
    } else if(location.pathname === '/add') {
      setPath(path => {
        const item = { ...path };
        item.home = false;
        item.add = true;
        item.noti = false;
        item.info = false;
        return item;
      })
    } else if(location.pathname === '/notiLog') {
      setPath(path => {
        const item = { ...path };
        item.home = false;
        item.add = false;
        item.noti = true;
        item.info = false;
        return item;
      })
    } else if(location.pathname === '/account') {
      setPath(path => {
        const item = { ...path };
        item.home = false;
        item.add = false;
        item.noti = false;
        item.info = true;
        return item;
      })
    }
  }

  useEffect(() => {
    showSelectPage();
    if(/Android/.test(navigator.userAgent)) {
      setPhoneModel("android");
    } else if(/iPhone|iPad|iPd/.test(navigator.userAgent)) {
      setPhoneModel("ios");
    }
  }, [location]);
  
  //페이지가 바뀔 때마다 스크롤 위치 초기화
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return unlisten;
  }, [history]);

  return (
    <>
      <footer className={styles.footerMain_m} style={phoneModel === "ios" ? {paddingBottom: "5%"} : null}>
        <div className={styles.footerMainContent_m}>
          <span className={styles.footerBtn_m} onClick={goHome}>
            {!path.home ? 
              <>
              <img className={styles.footerImg_m} src="/images/mobile/home.png"></img>
              <span style={{color:"#666666"}}>홈</span>
              </>
              : <>
                <img className={styles.footerImg_m} src="/images/mobile/home_on.png"></img>
                <span style={{color:"#5e9dd4"}}>홈</span>
                </>
            }
          </span>
          {/* <span className={styles.footerBtn_m} onClick={goAddUser}>
            {!path.add ? 
              <>
              <img className={styles.footerImg_m} src="/images/mobile/add2.png"></img>
              <span style={{color:"#666666"}}>등록</span>
              </>
              : <>
                <img className={styles.footerImg_m} src="/images/mobile/add2_on.png"></img>
                <span style={{color:"#5e9dd4"}}>등록</span>
                </>
            }
          </span> */}
          <span className={styles.footerBtn_m} onClick={goNotiLog}>
            {!path.noti ? 
              <>
              <img className={styles.footerImg_m} src="/images/mobile/noti.png"></img>
              <span style={{color:"#666666"}}>알림</span>
              </>
              : <>
                <img className={styles.footerImg_m} src="/images/mobile/noti_on.png"></img>
                <span style={{color:"#5e9dd4"}}>알림</span>
                </>
            }
            
          </span>
          <span className={styles.footerBtn_m} onClick={goAccount}>
            {!path.info ? 
              <>
              <img className={styles.footerImg_m} src="/images/mobile/info.png"></img>
              <span style={{color:"#666666"}}>마이페이지</span>
              </>
              : <>
                <img className={styles.footerImg_m} src="/images/mobile/info_on.png"></img>
                <span style={{color:"#5e9dd4"}}>마이페이지</span>
                </>
            }
          </span>
          {completeDialogVisible && (
              <Dialog
                className="completeDialog"
                width={"90vw"}
                height={"40vw"}
                closeIcon={false}
              >
                <p>
                  보호자는 이용할 수 없습니다.
                  <br></br>
                  <button onClick={closeCompleteDialog}>확인</button>
                </p>
              </Dialog>
            )}
        </div>
      </footer>
    </>
  );
}

export default FooterMobile;
